import { TITLES } from 'constants/pagesTitles';
import { useState, useEffect } from 'react';
import PageContainerImgBg from 'components/layout/PageContainer/PageContainerImgBg';
import SignUpPage from 'core/views/JoinPage/SignUpPage';
import { ROLES_LIST } from 'constants/joinPage';

const DigitalSignUp = () => {
  const [roleData, setRoleData] = useState(null);

  useEffect(() => {
    const data = ROLES_LIST.find((r) => r.url === 'individual');
    setRoleData(data);
  }, []);

  return (
    <>
      {roleData && (
        <PageContainerImgBg
          title={TITLES.signUpPage}
          imageBg={`/images/${roleData.index}-body-bg.jpg`}
          isHeaderNav
          isSignUpPage
        >
          <SignUpPage role={roleData} digital="true" />
        </PageContainerImgBg>
      )}
    </>
  );
};
export default DigitalSignUp;
